import { isClientIntakeUrl } from "@shared/client-intake-privacy";

// Once sensitive content has been visited, keep this document out of telemetry.
function isPrivateAdminUrl(value: string) {
  try { return new URL(value, window.location.origin).pathname.startsWith("/admin/smb"); } catch { return false; }
}
let privateDocument = isClientIntakeUrl(window.location.href) || isPrivateAdminUrl(window.location.href);
export function isClientIntakePrivateDocument() {
  privateDocument ||= isClientIntakeUrl(window.location.href) || isPrivateAdminUrl(window.location.href);
  return privateDocument;
}
for (const method of ["pushState", "replaceState"] as const) {
  const original = window.history[method].bind(window.history);
  window.history[method] = function (...args: Parameters<History[typeof method]>) {
    if (args[2] != null && (isClientIntakeUrl(String(args[2])) || isPrivateAdminUrl(String(args[2])))) privateDocument = true;
    original(args[0], args[1], args[2]);
    isClientIntakePrivateDocument();
  };
}
window.addEventListener("popstate", isClientIntakePrivateDocument);

// Captured only in memory, before telemetry initialization or page rendering.
let token: string | undefined;
if (window.location.pathname === "/intake") {
  const url = new URL(window.location.href);
  token = url.searchParams.get("t") ?? undefined;
  if (url.searchParams.has("t")) {
    url.searchParams.delete("t");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  }
}
export function takeClientIntakeToken() {
  const value = token;
  token = undefined;
  return value;
}
